import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { can, type Permission } from '@gwc/shared';
import { useAuth } from '../auth/AuthProvider';
import { PageSkeleton } from './Skeleton';

export function ProtectedRoute({
  permission,
  children,
}: {
  permission?: Permission;
  children?: React.ReactNode;
}) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <PageSkeleton lines={2} />;
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (permission && !can(user.roles, permission)) {
    return (
      <div className="mx-auto max-w-lg p-12 text-center">
        <h2 className="mb-2 text-2xl text-gold-200">Not authorized</h2>
        <p className="text-cream-300">You don't have permission to view this page.</p>
      </div>
    );
  }
  return children ?? <Outlet />;
}
